import { render } from "./logoffVerification.vue?vue&type=template&id=3e771004&scoped=true&ts=true"
import script from "./logoffVerification.vue?vue&type=script&lang=ts"
export * from "./logoffVerification.vue?vue&type=script&lang=ts"

import "./logoffVerification.vue?vue&type=style&index=0&id=3e771004&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e771004"]])